var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayNavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.00001V4.22001C2 2.01001 3.565 1.10501 5.48 2.21001L7.025 3.10001L8.57 3.99001C10.485 5.09501 10.485 6.90501 8.57 8.01001L7.025 8.90001L5.48 9.79001C3.565 10.895 2 9.99001 2 7.78001V6.00001Z",
    stroke: "#29448B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNavy);
export default __webpack_public_path__ + "static/media/play-navy.7812eacd8810420759242f8631c3efcc.svg";
export { ForwardRef as ReactComponent };